module.exports = __webpack_public_path__ + "static/media/movie.68ebbf46.mp4";